import React from 'react';
import Navbar from '../components/navBar';
import Footer from '../components/footer';
import MainVideo from '../components/mainVideo';
import GlobalLeaderSection from '../components/globalLeaderSection';
import WhatMakesUsSpecial from '../components/whatMakesUsSpecial';
import ShippingAcross from '../components/shippingAcross';
import TurnkeyServices from '../components/turnKeyService';
import DietaryHealthcareSection from '../components/dietaryHealthcareSection';
import CertificatesCarousel from '../components/certificates';
import CertificationBadges from '../components/certificateBages';
import ContactSection from '../components/contactSection';


function HomePage() {
  return (
    <div className="App">
    {/* <Navbar /> */}
    <MainVideo />
    <GlobalLeaderSection />
    <WhatMakesUsSpecial/>
    <ShippingAcross />
    <TurnkeyServices />
    <DietaryHealthcareSection />
    <CertificatesCarousel />
    <CertificationBadges />
    <ContactSection />
    {/* <Footer /> */}
    </div>
  );
}

export default HomePage;